import { render, staticRenderFns } from "./village-item.vue?vue&type=template&id=5ce040d1&scoped=true&"
import script from "./village-item.vue?vue&type=script&lang=js&"
export * from "./village-item.vue?vue&type=script&lang=js&"
import style0 from "./village-item.vue?vue&type=style&index=0&id=5ce040d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce040d1",
  null
  
)

export default component.exports